<template>
  <div class="app-wrapper">
    <!-- <Header /> -->
    <navbar />
    <app-main />
    <Footer />
  </div>
</template>

<script>
import ResizeMixin from './mixin/ResizeHandler'
import { mapGetters } from 'vuex'
import { Navbar, AppMain, Footer } from './components'
export default {
  name: 'Layout',
  components: {
    Navbar,
    AppMain,
    Footer
  },
  mixins: [ResizeMixin],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['device'])
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper{
  padding-top: 88px;
  position: relative;
  .top{
    top: 0;
    z-index: 9;
    position: sticky;
  }
}
.pc-min-width{
  min-width: 1280px;
  overflow-x: auto;
}
.padding{
  padding-bottom: 100px;
}
</style>
